/* ============
 * Members Page
 * ============
 *
 * This is the page for members.
 */
import Vue from 'vue';
import Moment from 'moment';
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import Tooltip from 'tooltip.js';
import { mapGetters } from 'vuex';

window.jQuery = require('jquery');

export default {
  components: {
    FullCalendar
  },

  data: () => ({ 
    calendarPlugins: [ timeGridPlugin ],
    organizationsLoading: true,
    calendarLoading: true,
    organizations: [],
    organization_settings: null,
    events: [],

    current_tab: 'organizations',
    calendar_data_type: 'businesshours',
    api_location: '',
    min_time: '06:00',
  }),
  
  computed: {
    ...mapGetters([
      'account',
    ]),

    timeslot_gap() {
      var timeslot_gap = '00:15';
      /*if (this.organization_settings && this.organization_settings.timeslot_gap) {
        timeslot_gap = '00:' + this.organization_settings.timeslot_gap;
      }*/

      return timeslot_gap;
    },
  },


  watch: {
    current_tab: function (tab) {
      switch (tab) {
        case 'organizations':
          this.organizationsLoading = true;
          this.getMembers();
          break;

        case 'calendar_schedule':
          this.calendar_data_type = 'businesshours'; //businesshours
          this.calendarLoading = true;
          this.getSchedule();
          break;
      }
    },

    calendar_data_type: function (type) {
      this.calendarLoading = true;
      this.getSchedule();
    },
  },

  mounted() {
    this.api_location = process.env.API_LOCATION + '/';
    this.getMembers();
  },

  methods: {
    getMembers() {
      Vue.$http.get('/membership/organization_members').then(data => {
        this.organization_members = data.data;
        this.organizationsLoading = false;
      });
    },

    showToolTip(info) {
      var time = Moment(info.event.start).format('H:mm') + ' - ' + Moment(info.event.end).format('H:mm');
      var template = '';
      if (this.calendar_data_type == 'businesshours') {
        template = '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div>'+time+'</div>';
      } else if(this.calendar_data_type == 'bookings') {
        var product = 'Product: ' + info.event.extendedProps.productName;
        var organization = 'Organization: ' + info.event.extendedProps.organizationName;
        template = '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div>'+time+'<div><small>'+product+'</small></div><div><small>'+organization+'</small></div></div>';
      }
      var tooltip = new Tooltip(info.el, {
        title: info.event.title,
        placement: 'top',
        trigger: 'hover',
        container: 'body',
        html: true,
        template: template
      });
    },


    getSchedule() {
      Vue.$http.get('/membership/calendar?type=' + this.calendar_data_type).then(data => {
        var events = [];
        var min_time = '00:00';
        data.data.forEach(s => {
          switch (this.calendar_data_type){
            case 'businesshours':
              events.push({
                title: s.organization_member_product.organization_member.organization.name,
                daysOfWeek: Moment().day(s.day).format('d'),
                startTime: s.start_time,
                endTime: s.end_time,
                backgroundColor: s.organization_member_product.organization_member.color,
                borderColor: s.organization_member_product.organization_member.color,
              });
              break;

            case 'bookings':
              events.push({
                id: s.id,
                product_id: s.organization_member_product.product_id,
                member_id: s.organization_member_product.organization_member_id,
                client_id: s.client_id,
                data_date: s.date,
                start_time: s.start_time,
                end_time: s.end_time,

                title: s.client.name,
                productName: s.organization_member_product.product.name,
                organizationName: s.organization_member_product.organization_member.organization.name,
                start: s.date + ' ' + s.start_time,
                end: s.date + ' ' + s.end_time,
                backgroundColor: s.organization_member_product.organization_member.color,
                borderColor: s.organization_member_product.organization_member.color,
              });
              break;
          }
        });

        this.events = events;
        this.calendarLoading = false;
      });
    },

    navigateTab(tab) {
      var new_tab = tab.label.toLowerCase();

      if (new_tab != this.current_tab) {
        switch (new_tab){
          case 'members':
            this.organizationsLoading = true;
            this.getMembers();
            break;

          case 'schedule':
            break;
        }
      }

    },



  	formatDate(date) {
      if (!date) return '';
  		return Moment(date).format('MMM DD, YYYY');
  	}
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/membership/index/index.js